import validatorHook from './src/hook';
import { VXETable } from '../v-x-e-table';
export var VxeModuleValidator = {
    install: function () {
        VXETable.hooks.add('$tableValidator', validatorHook);
    }
};
export var Validator = VxeModuleValidator;
export default VxeModuleValidator;
